<template>
  <fb-form-body>
    <el-form ref="form" :model="formData" label-width="auto">
      <el-form-item :label="$t('lang.专题名称') + '：'" required>
        <nation-input v-model="langName" />
      </el-form-item>

      <el-form-item :label="$t('lang.专题描述') + '：'" required>
        <nation-input v-model="langDescription" />
      </el-form-item>

      <el-form-item :label="$t('lang.主语言') + '：'" required>
        <el-radio-group v-model="formData.lang" style="min-width: 800px">
          <el-row :gutter="24">
            <el-col :span="6" v-for="lang in langList" :key="lang.value + '_key'">
              <el-radio :label="lang.value">{{ lang.name }}（{{ lang.value }}）</el-radio>
            </el-col>
          </el-row>
        </el-radio-group>

      </el-form-item>

      <el-form-item :label="$t('lang.封面') + '：'" required>
        <pic-upload
            :limit="1"
            :action="api.upload"
            :download-url="api.downloadImg"
            :data="{category: 'RECIPE'}"
            v-model="formData.cover" />

      </el-form-item>


      <el-form-item>
        <el-button type="primary" @click="handleSubmit">{{ $t('lang.确定') }}</el-button>
        <el-button @click="handleReset">{{ $t('lang.重置') }}</el-button>
      </el-form-item>

    </el-form>
  </fb-form-body>
</template>

<script>
import {handleFilterLang} from "../../utlis/utlis";
import NationInput from "../../components/nation/NationInput";
import PicUpload from "../../components/pic-upload/PicUpload";

export default {
  name: "GroupRecipeEdit",
  components: {PicUpload, NationInput},
  data() {
    return {
      api: {
        update: this.$api.specRecipe.update,
        detail: this.$api.specRecipe.detail,
        upload: this.$api.file.upload,
        download: this.$api.file.download,
        downloadImg: this.$api.file.downloadImg,
      },
      formData: {
        code: "",
        lang: '',
        cover: "",
        brandOwnerCode: ""
      },
      langs: [],
      langName: {},
      langDescription: {},

      langList: [],
    }
  },
  methods: {
    handleSubmit() {
      let params = {
        ...this.formData,
        langs: this.handleFormatLangData(),
        brandOwnerCode: this.$store.state.userInfo.brandOwnerCode,
      }

      this.$http.post(this.api.update, params).then(res => {
        if(res.data.status != 200) {
          this.$message.error(res.data.desc);
          return;
        }
        this.$message.success(res.data.desc);
        this.$router.back();
      })
    },

    handleFormatLangData() {
      console.log('name', this.langName);
      console.log('desc', this.langDescription)
      let langs = this.langs.map(item => {
        if(Object.keys(this.langName)) {
          item.name = this.langName[item.lang]
        }

        if(Object.keys(this.langDescription)) {
          item.description = this.langDescription[item.lang]
        }
        return item;
      })
      return langs;
    },

    // 重置
    handleReset() {
      for (const key in this.formData) {
        if(key !== "code") this.formData[key] = '';
      }
      this.langs = this.langs.map(item => {
        return {
          name: "",
          description: "",
          lang: item.lang,
        }
      })

      this.langDescription = {};
      this.langName = {};

      this.$refs.upload.clearFiles();
    },


    handleFormatLang() {
      let list = handleFilterLang(this);
      if(list && list.length) {
        this.langs = list.map(item => {
          return {
            name: "",
            description: "",
            lang: item.value,
          }
        })
      }
      this.langList = list;
    },

    handleLoadDetail() {
      this.$http.post(this.api.detail, this.$qs.stringify(this.$route.query)).then(res => {
        if(res.data.status != 200) {
          this.$message.error(res.data.desc);
          return;
        }

        for (const key in this.formData) {
          this.formData[key] = res.data.data.specRecipe[key];
        }

        this.handleFormatLangs(res.data.data.specRecipe.langs);
      })
    },

    // 格式语言
    handleFormatLangs(list) {
      let langs =list.map(item => {
        return {
          name: item.name,
          description: item.description,
          lang: item.lang,
        }
      });

      let langDescription = {};
      let langName = {};

      langs.forEach(item => {
         langDescription[item.lang] = item.description;
         langName[item.lang] = item.name;
       })

      this.langName = langName;
      this.langDescription = langDescription;
      this.langs = this.handleMergeData(langs, this.langs);
    },

    handleMergeData(arr1, arr2) {
      let mergedMap  = {};
      [arr1, arr2].forEach(arr => {
        arr.forEach(item => {
          let target = {...item, ...mergedMap[item.lang]}
          mergedMap[item.lang] = target;
        });
      });
      return Object.values(mergedMap);
    }
  },
  created() {
    this.handleFormatLang();
    this.handleLoadDetail();
  }
}
</script>

<style scoped>

.el-form {
  width: 500px;
}

.lang-box {
  display: flex;
  margin-top: 14px;
}


/deep/ .el-radio {
  line-height: 40px;
}

</style>
